import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import {
  displayProfileModal,
  setProfileModalPage,
} from '../../../modules/profile/actions/creators'

import {
  doSetUserSettings,
  doGetUserSettings,
} from '../../../controllers/Profile.js'

import SettingsPage from '../components/SettingsPage/SettingsPage'

const mapStateToProps = reduxState => {
  const { auth, profile } = reduxState

  const { accessToken } = auth

  const { primaryInfo, showProfileModal, profileModalPage } = profile

  return {
    accessToken,
    primaryInfo,
    showProfileModal,
    profileModalPage,
    doGetUserSettings,
    doSetUserSettings,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      displayProfileModal,
      setProfileModalPage,
    },
    dispatch,
  )

const ConnectedSettingsPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SettingsPage)

export default ConnectedSettingsPage
